/* eslint-disable */
export default {
    cartItems: [],
    wishList: [],
    restaurant_id: null
}
/* eslint-enable */
